import { defineNuxtRouteMiddleware, navigateTo, useNuxtApp } from 'nuxt/app'
import SettingsService from '~/services/SettingsService';

export default defineNuxtRouteMiddleware(async (to, from) => {
  // Nuxt uygulamasını al
  const nuxtApp = useNuxtApp();
  const localePath = nuxtApp.$localePath;
  
  try {
    const settingsService = SettingsService.getInstance();
    const systemSettingsResponse = await settingsService.getSystemSettings();
    
    // Eğer maintenance sayfasındaysak ve bakım modu kapalıysa ana sayfaya yönlendir
    if (to.path === '/maintenance' && systemSettingsResponse?.data?.maintenance_mode !== true) {
      return navigateTo(localePath('/'))
    }
    
    // Bakım modu aktifse ve maintenance sayfasında değilse, maintenance sayfasına yönlendir
    if (systemSettingsResponse?.data?.maintenance_mode === true && to.path !== '/maintenance') {
      return navigateTo(localePath('/maintenance'))
    }
  } catch (error) {
    console.error('Sistem ayarları kontrol edilirken hata oluştu:', error)
  }
}) 